module.exports = __webpack_public_path__ + "img/art-39.5407580a.png";